<template>
  <b-container fluid>
    <b-row>
     <b-col :lg="cols">
        <card>
          <TableActionHeader 
            @filterChange="onFilterChange" 
            @newItem="onNewItem"
            :newButton="$UIPrivilegeC('timetables/seasons')">
          </TableActionHeader> 
          <SeasonTable :filter="filter" @selectItem="onSelectItem"></SeasonTable>
        </card>
      </b-col>
      <b-col>
        <InfoCard v-if="action == ''"></InfoCard>
        <card v-if="action == 'new'">
           <CardHeader :title="$t('item.new')"/>
             <SeasonForm :item="item" :action="action" v-on:newItem="onItemUpdated" />
        </card>
        <card v-if="action == 'item' && item">
          <CardHeader :title="item ? item.id: ''" type="item" />
            <tabs>
              <tab-pane title="tab-1" key="tab-1">
                 <b-icon id="season-settings" slot="title" icon="gear" scale='1.1'></b-icon> 
                 <b-popover target="season-settings" triggers="hover" placement="top">
                   {{$t("timetable.tooltips.settings")}}
                 </b-popover>
                   <SeasonForm :item="item" :action="action" />
              </tab-pane>

              <tab-pane title="tab-3" key="tab-3">
                <b-icon id="season-routes" slot="title" icon="card-list" scale='1.1'></b-icon> 
                <b-popover target="season-routes" triggers="hover" placement="top">
                  {{$t('nav.timetables.routes')}}
                </b-popover>
                 <TableActionHeader @filterChange="onRouteFilterChange" :newButton="false"/> 
                  <SeasonRouteTable  :filter="routeFilter" :item="item" v-on:updateItem="onItemUpdated" />
              </tab-pane>
            </tabs>
          </card>
      </b-col>
     </b-row>
  </b-container>
</template>

<script>

import TableActionHeader from '@/components/Misc/TableActionHeader'
import CardHeader from '@/components/Misc/CardHeader'
import i18n from '@/i18n'

import SeasonForm from '@/components/Timetable/SeasonForm'
import SeasonTable from '@/components/Timetable/SeasonTable'
import SeasonRouteTable from '@/components/Timetable/SeasonRouteTable'

export default {
    components: {
        TableActionHeader, 
        CardHeader, 
        SeasonForm, 
        SeasonTable, 
        SeasonRouteTable
    },
    data() {
        return {
            cols: 8,
            filter: null,
            routeFilter: null,
            item: {},
            tabIndex: 1,
            action: ""
        }        
    },
    computed: {
        formTitle(){
            return i18n.t('item.' + this.formType);
        }
    },
    methods: {
        onFilterChange: function(filter) {
            this.filter = filter;
        },
        onRouteFilterChange: function(filter) {
            this.routeFilter = filter;
        },
        onNewItem: function() {
            this.item = {};        
            this.action = "new"
        },
        onItemUpdated: function(item) {
            this.item = JSON.parse(JSON.stringify(item));                    
            this.action = "item"
            this.$store.dispatch('timetable/getSeasonList');
        },
        onSelectItem: function(item) { 
            if (item)
                this.item = JSON.parse(JSON.stringify(item));  
            this.action = "item";
        },
    }


}

</script>
